import React, { useState } from 'react';
import { ThemeContext } from '../../context/ThemeContext';
import { graphql } from 'gatsby';
import { OmIcon } from '../../../../component-library-react/src/components';
import OmButton from '../../components/forms/OmButton';
import './TriggerQuestion.scss';


const getIcon = (icon, icon_name) => {
    if (icon_name || icon) {
        if (icon_name) {
            return <OmIcon iconName={icon_name}></OmIcon>;
        } else {
            return <OmIcon imageUrl={icon.url}></OmIcon>;
        }
    }
    return '';
};

const getContent = (currentContent, button_one_content, button_two_content ) => {
    if (currentContent === 0) {
        return '';
    } else if (currentContent > 0) {
        return (
            <div
                className="option-content"
                dangerouslySetInnerHTML={{ __html: button_one_content }}
            />
        );
    } else if (currentContent < 0) {
        return (
            <div
                className="option-content"
                dangerouslySetInnerHTML={{ __html: button_two_content }}
            />
        );
    }

    return '';
};

const TriggerQuestion = ({ triggerQuestionContent }) => {
    const [currentContent, setCurrentContent] = useState(0);
    const theme = React.useContext(ThemeContext);

    if (!triggerQuestionContent) {
        return '';
    }

    const {
        icon,
        icon_name,
        background,
        question,
        button_one_text,
        button_one_content,
        button_two_text,
        button_two_content,
        button,
    } = triggerQuestionContent;

    return (
        <div className={`${theme} trigger-question-container`}>
            <div
                className="trigger-question-image-wrapper"
                style={{
                    backgroundImage: `url(${background && background.url})`,
                }}
            />
            <div className="trigger-question-content-wrapper">
                <div>{getIcon(icon, icon_name)}</div>
                <div
                    className="question-wrapper"
                    dangerouslySetInnerHTML={{ __html: question }}
                />
                <div className="option-button-wrapper">
                    <OmButton
                        className={currentContent > 0 ? 'selected-button' : ''}
                        size="small"
                        type="secondary"
                        text={button_one_text}
                        disabled={false}
                        withIcon={false}
                        onClick={() => setCurrentContent(1)}
                    />
                    <OmButton
                        className={currentContent < 0 ? 'selected-button' : ''}
                        size="small"
                        type="secondary"
                        text={button_two_text}
                        disabled={false}
                        withIcon={false}
                        onClick={() => setCurrentContent(-1)}
                    />
                </div>
                <div className="option-content-wrapper">
                    {getContent(currentContent, button_one_content, button_two_content)}
                </div>
                {currentContent !== 0 && (
                    <div>
                        <OmButton
                            size="large"
                            type="primary"
                            text={button && button.display_text}
                            disabled={false}
                            withIcon={true}
                            actionObject={
                                button && button.action && button.action[0]
                            }
                        />
                    </div>
                )}
            </div>
        </div>
    );
};

export const pageQuery = graphql`
    fragment TriggerQuestion on Contentstack_trigger_question {
        id
        uid
        icon {
            ...File
        }
        icon_name
        background {
            ...File
        }
        question
        button_one_text
        button_one_content
        button_two_text
        button_two_content
        button {
            ...TriggerQuestionButton
        }
    }
`;

export default TriggerQuestion;
